import React, { useState, useEffect, useRef } from "react";
import ReactInput from "react-input-range";
import * as S from "./index.styles";

interface IPriceFilter {
  onChangeComplete: Function;
  min: number;
  max: number;
}

export const PriceFilter: React.FC<IPriceFilter> = ({
  onChangeComplete = () => {},
  min = 0,
  max = 200,
}) => {
  const [range, setRangeValue] = useState({ min, max });
  useEffect(() => {
    setRangeValue({ min, max });
  }, [min, max]);
  return (
    <S.PriceFilter>
      <ReactInput
        formatLabel={(value) => `₹${value}`}
        maxValue={max}
        minValue={min}
        value={range}
        step={25}
        onChange={(value) => setRangeValue(value)}
        onChangeComplete={(value) => onChangeComplete(value)}
      />
      <span className="fl">
        <i className="icon-rupee fl ico12 padT3"></i> {range.min}
      </span>
      <span className="fr">
        <i className="icon-rupee fl ico12 padT3"></i> {range.max}
      </span>
    </S.PriceFilter>
  );
};

export default React.memo(PriceFilter);
